export default __webpack_public_path__ + "static/BHF-full_05-142488c84f7441fdf18b5a5c34ae6f17.jpeg";